import React, { Component } from 'react';
import store from '../store/uploaddata-store';
import { Form, Input, Button, TextArea } from 'semantic-ui-react'
import eb from '../utils/EventBus';
import emailstore from '../store/email-store';
import {observer} from 'mobx-react';
import axios from 'axios';


class SendEmail extends Component {

  constructor(props) {
    super(props);
  }


  componentDidMount() {
    emailstore.newEmail = {};
    eb.on('email-sent', () => this.props.history.push('/sendemail'));
  }



  render() {

    const em = emailstore.newEmail || {};
    return (
       <div className="buyer-invoice">
         <div className="title">
          <h4 align="left">Send Email</h4>
         </div>

        <Form>

            <Form.Field inline>
              <label>To</label>
              <Input value = {em.toaddr} onChange={(evt, { value }) => emailstore.setToAddr(value)} className="w-100" />
            </Form.Field>

            <Form.Field inline>
              <label>Subject</label>
               <Input value = {em.sub} onChange={(evt, { value }) => emailstore.setSub(value)} className="w-100" />
            </Form.Field>

            <Form.Field inline>
              <label>Body</label>
              <TextArea input type="text" value = {em.body} onChange={(evt, { value }) => emailstore.setBody(value)} className="w-100" />
            </Form.Field>

            <Button primary  className="save" onClick={emailstore.sendEmail}> Send </Button>

        </Form>

        <div className="footer">

        </div>
      </div>

    );
  }

}

export default observer(SendEmail);




// WEBPACK FOOTER //
// ./src/containers/SendEmail.js